import axios from 'axios'
import { T_APP_TYPE } from '@/config'
axios.interceptors.request.use(function (config) {
  let T_APP_TYPE_2;
  // || config.url.indexOf('sign_package') > -1
  if (config.url.indexOf('wechat_h5_pay') > -1 || config.url.indexOf('wechat_pay') > -1) {
    // T_APP_TYPE_2 = 'WEIXIN/SUNNY_MINIPROGRAM';
  }
  let sid1 = window && window.IntelligentCookie && window.IntelligentCookie.get('gs_mall_session_id')
  let sid = sid1 ? decodeURIComponent(sid1) : '1';
  let TAT = T_APP_TYPE_2 || T_APP_TYPE;
  Object.assign(config.headers, {
    'session_id': sid,
    'T-App-Type': TAT
  })
  return config
}, function (error) {
  return Promise.reject(error)
})
export default axios



// WEBPACK FOOTER //
// ./src/utils/fetch.js